"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RELATION_MAPPING_ERROR = exports.RELATION_ROWS_COLUMN_ID = exports.WEBHOOK_WHOLE_PAYLOAD_COLUMN_ID = exports.WEBHOOK_PAYLOAD_TABLE_ID = exports.INPUT_MAPPING_OPTIONS_SOURCE = void 0;
exports.isOptionsInputMapping = isOptionsInputMapping;
exports.selectWebhookPayloadMappings = selectWebhookPayloadMappings;
exports.applyWebhookPayloadMappings = applyWebhookPayloadMappings;
exports.hasValidRelationInputMappings = hasValidRelationInputMappings;
/** Source of a mapping that hands over the option labels of a select column. */
exports.INPUT_MAPPING_OPTIONS_SOURCE = 'options';
function isOptionsInputMapping(mapping) {
    return mapping.source === exports.INPUT_MAPPING_OPTIONS_SOURCE;
}
/** Input table marker of a mapping that reads the data of a webhook call. */
exports.WEBHOOK_PAYLOAD_TABLE_ID = '__webhook_payload__';
/** Column marker for the whole data of a webhook call. */
exports.WEBHOOK_WHOLE_PAYLOAD_COLUMN_ID = 'payload';
/** The mappings of an automation that read the data of a webhook call. */
function selectWebhookPayloadMappings(mappings) {
    return (mappings ?? []).flatMap(mapping => mapping.inputTableId === exports.WEBHOOK_PAYLOAD_TABLE_ID && mapping.columnId
        ? [{ columnId: mapping.columnId, schemaFieldId: mapping.schemaFieldId }]
        : []);
}
/**
 * The start fields of the workflow for one webhook call. A mapped field of
 * the call moves to its start field; an unmapped field keeps its name, so a
 * call whose fields are named like the start fields needs no mapping.
 * Every mapping reads the call as it arrived, whatever the order.
 */
function applyWebhookPayloadMappings(data, mappings) {
    const mapped = { ...data };
    for (const mapping of mappings) {
        if (mapping.columnId !== exports.WEBHOOK_WHOLE_PAYLOAD_COLUMN_ID &&
            mapping.columnId !== mapping.schemaFieldId) {
            delete mapped[mapping.columnId];
        }
    }
    for (const mapping of mappings) {
        mapped[mapping.schemaFieldId] =
            mapping.columnId === exports.WEBHOOK_WHOLE_PAYLOAD_COLUMN_ID
                ? data
                : data[mapping.columnId];
    }
    return mapped;
}
/** Whole relation input, delivered as one JSON list keyed by workflow field ID. */
exports.RELATION_ROWS_COLUMN_ID = '__relation_rows__';
exports.RELATION_MAPPING_ERROR = 'Map the relation again to a JSON input.';
/** Shared by editor readiness, prepare/preview and the execution boundary.
 * Omitting fields only checks source bindings; the published schema is checked
 * when available, before the workflow is dispatched.
 */
function hasValidRelationInputMappings(mappings, tables, fields) {
    return (mappings ?? []).every(mapping => {
        if (!mapping.columnId)
            return true;
        const source = (tables ?? []).find(table => table.id === mapping.inputTableId);
        const isRelated = source?.role === 'secondary';
        const isSentinel = mapping.columnId === exports.RELATION_ROWS_COLUMN_ID;
        // An explicit missing binding is not a main-table mapping. The webhook
        // payload sentinel uses its existing independent mapping contract.
        if (mapping.inputTableId &&
            mapping.inputTableId !== 'lead' &&
            mapping.inputTableId !== exports.WEBHOOK_PAYLOAD_TABLE_ID &&
            !source)
            return false;
        // Options are read from a select column of the main table only.
        if (isOptionsInputMapping(mapping))
            return (!isRelated &&
                !isSentinel &&
                mapping.inputTableId !== exports.WEBHOOK_PAYLOAD_TABLE_ID);
        if (!isRelated && !isSentinel)
            return true;
        if (!isRelated || !source.linkedVia || !isSentinel)
            return false;
        return (!fields ||
            fields.some(field => field.id === mapping.schemaFieldId &&
                field.type?.toLowerCase() === 'json'));
    });
}
